// General Settings IDs
export const ID_GENERAL_SETTINGS = "5590fe0f-69fc-9ff9-699d-d9a9defd98ba";
export const ID_CUSTOMER_ACCOUNT = "5590fe0f-69fc-9ff9-699d-d9a9defd98bb";
export const ID_LANGUAGE = "5590fe0f-69fc-9ff9-699d-d9a9defd98bf";
export const ID_VAT_RATE = "5590fe0f-69fc-9ff9-699d-d9a9defd98bg";
export const ID_SALE_SUPPORT = "5590fe0f-69fc-9ff9-699d-d9a9defd98bk";
export const ID_SALES_METHOD = "5590fe0f-69fc-9ff9-699d-d9a9defd98be";
export const ID_INFORMATION_MODE = "5590fe0f-69fc-9ff9-699d-d9a9defd98bi";
export const ID_PAYMENT_METHOD = "5590fe0f-69fc-9ff9-699d-d9a9defd98bd";
export const ID_LOGO = "5590fe0f-69fc-9ff9-699d-d9a9defd98bj";
export const ID_CURRENCY = "5590fe0f-69fc-9ff9-699d-d9a9defd98bl";
export const ID_FIDELITY = "5590fe0f-69fc-9ff9-699d-d9a9defd98bn";
export const ID_POS_INTERCONNECTION = "325f711b-a383-425a-9d8b-60fc261fe12c";
export const ID_AGGREGATOR = "6e63d928-d76f-4278-a85a-9fc12d594d56";
export const ID_THIRD_PARTY = "0c942cca-c8ca-480b-9e99-086917c2333b";
export const ID_LOCATION_MANAGEMENT = "6dad086c-a6cb-439f-a1d6-d8fb29070487";
export const ID_FOOD_COURT = "41447411-496d-479b-bae5-f54f22eed438";

// Applications IDs
export const ID_APPLICATIONS = "5590fe0f-69fc-9ff9-699d-d9a9defd11aa";
export const ID_KIOSK = "5590fe0f-69fc-9ff9-699d-d9a9defd11ab";
export const ID_KIOSK_TEMPLATE = "5590fe0f-69fc-9ff9-699d-d9a9defd11ac";
export const ID_KIOSK_PERIPHERAL = "5590fe0f-69fc-9ff9-699d-d9a9defd11ad";
export const ID_SCAN_TO_START = "5590fe0f-69fc-9ff9-699d-d9a9defd11e1";
export const ID_SCAN_TO = "5590fe0f-69fc-9ff9-699d-d9a9defd11e2";
export const ID_SERVIO = "5590fe0f-69fc-9ff9-699d-d9a9defd11e3";
export const ID_CC = "5590fe0f-69fc-9ff9-699d-d9a9defd11b1";
export const ID_CC_SETUP = "5590fe0f-69fc-9ff9-699d-d9a9defd11b2";
export const ID_KDS = "5590fe0f-69fc-9ff9-699d-d9a9defd11c1";
export const ID_KDS_APP_SETUP = "5590fe0f-69fc-9ff9-699d-d9a9defd11c2";
export const ID_KDS_PERIPHERAL = "5590fe0f-69fc-9ff9-699d-d9a9defd11c3";
export const ID_POS = "5590fe0f-69fc-9ff9-699d-d9a9defd11d1";
export const ID_POS_TEMPLATE = "5590fe0f-69fc-9ff9-699d-d9a9defd11d2";
export const ID_POS_PERIPHERAL = "5590fe0f-69fc-9ff9-699d-d9a9defd11d3";
export const ID_ORB = "5590fe0f-69fc-9ff9-699d-d9a90056a";
export const ID_ORB_PROJECT_SETUP = "75a03460-3de1-43c0-97ed-1636d0cde2c9";
export const ID_ORB_SETUP = "50d215f5-ac00-4f8c-897b-442b2d9968b3";

// Peripherals IDs
export const ID_PERIPHERALS = "5590fe0f-69fc-9ff9-699d-d9a9defd12aa";
export const ID_PRINTERS = "5590fe0f-69fc-9ff9-699d-d9a9defd12ab";
export const ID_MONETICS = "5590fe0f-69fc-9ff9-699d-d9a9defd12ac";
export const ID_COINERS = "5590fe0f-69fc-9ff9-699d-d9a9defd12ad";
